import React from 'react'
import { separate } from '../../Seprate/Seprate'
import Style from './FactorList.module.css'

const ShoppingList = ({data}) => {
    return (
            <li className={Style.ShoppingList} >
                <h3 className={Style.name}>{data.name}</h3>
                <h3 className={Style.count}>{data.count} عدد </h3>
                <h3 className={Style.price}>{separate(data.price)}تومان</h3>
                {/* <p className={props.HideCounter? Style.WidthHolder : null}> {props.dataFactor.name}  <span className={props.HideCounter ? null:Style.hideSpan }>({props.Count})</span> </p>
                <div className={Style.PriceList}><strong >{separate(props.dataFactor.price)}<span>تومان</span></strong></div> */}
            </li>
    )
}

export default ShoppingList
